// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pp-6";
export var imgContainer = "_pp-3";
export var menuIcon = "_pp-5";
export var pillWrapper = "_pp-2";
export var pillsContainer = "_pp-1";
export var subscriptionCard = "_pp-0";
export var subscriptionLogo = "_pp-4";